import { defineComponent as o, openBlock as t, createBlock as l, normalizeProps as n, guardReactiveProps as p, withCtx as a, renderSlot as s, createElementVNode as c } from "vue";
import d from "../CdrIcon.vue.mjs";
const i = /* @__PURE__ */ c("path", {
  role: "presentation",
  "fill-rule": "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3.293-5.293a1 1 0 001.414-1.414L9.121 7.707a1 1 0 10-1.414 1.414l7.586 7.586z",
  "clip-rule": "evenodd"
}, null, -1), _ = /* @__PURE__ */ o({
  name: "ErrorFill",
  __name: "error-fill",
  props: {
    props: {
      type: Object
    }
  },
  setup(e) {
    return (r, m) => (t(), l(d, n(p(e.props)), {
      default: a(() => [s(r.$slots, "default"), i]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
